import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";
import {StaffTestImportStatus} from "../../models/staff-test-import-status.model";

export interface StaffTestImportService {
    getStaffTestImportStatus: (districtId: string) => angular.IPromise<StaffTestImportStatus>;
    staffTestImport: (districtId: string) => angular.IPromise<number>;
    //initially it was number
    redoStaffTestImport: (districtId: string) => angular.IPromise<number>;
    getLastStartedOnTimeForRedo:() => string;
    getLastCompletionTimeForRedo:()=> string;
    setLastStartedOnTimeForRedo:(time: string) => void;
}

interface ImportProgressResponse { data: StaffTestImportStatus; }

/* @ngInject */
export function staffTestImportService(API_URL: ApiUrl, $http: angular.IHttpService, $q: angular.IQService): StaffTestImportService {
    let handleErrorResponse = (errorResponse): any => {
        return errorResponse && errorResponse.status === 404 ? [] : $q.reject(errorResponse) ;
    };

    return {
        getStaffTestImportStatus: (districtId: string): angular.IPromise<StaffTestImportStatus> => {
            return $http.get(`${API_URL.staffMatchStatus.replace(/\:districtId/, districtId)}`)
                .then((response: ImportProgressResponse) => {
                    return response.data;
                }, handleErrorResponse);
        },
        staffTestImport: (districtId: string): angular.IPromise<number> => {
            return $http.post(`${API_URL.matchStaff.replace(/\:districtId/, districtId)}`, "")
                .then((response: {status: number}) => {
                    return response.status;
                }, handleErrorResponse);
        },
        redoStaffTestImport: (districtId: string): angular.IPromise<number> => {
            return $http.post(`${API_URL.redoStaffTestImport.replace(/\:districtId/, districtId)}`, "")
                .then((response: {status: number}) => {
                    return response.status;
                }, handleErrorResponse);
        },
        getLastStartedOnTimeForRedo:(): string => {
            return this.lastRedoTime;
        },
        getLastCompletionTimeForRedo:(): string => {
            return this.lastRedoTime;
        },
        setLastStartedOnTimeForRedo:(time: string): void => {
            this.lastRedoTime = time;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/staff-test-import/staff-test-import.service.ts